import List from '../../../../components/People/Salaries/Lines/List'
import SalariesLinesModal from '../../../../components/People/Salaries/Lines/SalaryLinesModal'
import React, { Fragment } from 'react'

function SalaryLines(props) {
  return (
    <Fragment>
      <SalariesLinesModal {...props} />
      <List {...props} />
    </Fragment>
  )
}

export default SalaryLines
